/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchCommentReplyDataParser = 
/* #__PURE__ */ parsers.object([['comment', codecString]]);
export class PatchCommentReplyData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchCommentReplyDataParser.decode(input).map(res => new PatchCommentReplyData(res));
    }
    static unsafeDecode(input) {
        return PatchCommentReplyData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchCommentReplyDataParser.encode(data);
    }
    static schema() {
        return PatchCommentReplyDataParser.schema();
    }
}
